import { csrfApi } from '@/api'

interface ICSRFState {
  _csrf: string
}

const BASE = '/csrf'

export const getCSRF = (): Promise<ICSRFState> => {
  return csrfApi.get(`${BASE}`)
}
